import { Seller } from '../models/Seller';
import { post } from '../utils/backend';
import { mock, getMockData } from './mock/Mock';
import './mock/SellerMock';

export interface SellerListRequest {
    keyword?: string;
    deposit?: 'all' | 'full' | 'partial' | 'none';
    isVerified?: 'all' | 'yes' | 'no';
    isSuperIndividual?: 'all' | 'yes' | 'no';
    sortBy?: 'registerTime' | 'level' | 'consultCount' | 'orderCount' | 'grossConversionRate' | 'netConversionRate' | 'deposit' | 'unwithdrawAmount';
    sortOrder?: 'asc' | 'desc';
    page?: number;
    pageSize?: number;
}

export interface UpdateSuperIndividualRequest {
    sellerId: string;
    isSuperIndividual: 0 | 1;
}

export interface UpdateBlacklistRequest {
    sellerId: string;
    type: 0 | 1;
    reason: string;
}

const getSellerList = async (params: SellerListRequest): Promise<Seller[]> => {
    if (mock) {
        return getMockData("getSellerList");
    }
    const resultOrErrorCode = await post<SellerListRequest, Seller[]>('/api/seller/list', params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const updateSuperIndividual = async (params: UpdateSuperIndividualRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<UpdateSuperIndividualRequest, void>('/api/seller/setSuperIndividual', params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return true;
};

const updateBlacklist = async (params: UpdateBlacklistRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<UpdateBlacklistRequest, void>('/api/seller/blacklist', params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return true;
};

export const SellerApi = {
    getSellerList,
    updateSuperIndividual,
    updateBlacklist
}; 